// Phase 1C — centralized chain validation.
//
// Fail-closed. Never derive the expected chain from the API response.
// Phase 1C is locked to Base Sepolia (84532); the constant is authoritative.

export const PHASE_1C_EXPECTED_CHAIN_ID = 84532;

export class ChainMismatchError extends Error {
  code = "CHAIN_MISMATCH" as const;
  actual: number;
  expected: number;
  endpoint: string;
  constructor(actual: number, expected: number, endpoint: string) {
    super(
      `CHAIN_MISMATCH on ${endpoint}: got ${Number.isFinite(actual) ? actual : "missing"}, expected ${expected}`,
    );
    this.actual = actual;
    this.expected = expected;
    this.endpoint = endpoint;
  }
}

export function expectedChainId(): number {
  // Hardcoded for Phase 1C. Env cannot weaken this guard.
  return PHASE_1C_EXPECTED_CHAIN_ID;
}

/**
 * Throws ChainMismatchError if meta.chain_id is missing or != expected.
 * The caller MUST NOT publish/update viewer state when this throws.
 */
export function validateChainMeta(
  meta: { chain_id?: unknown } | null | undefined,
  endpoint: string,
  expected: number = expectedChainId(),
): void {
  const rawChain = meta && (meta as { chain_id?: unknown }).chain_id;
  const actual = typeof rawChain === "number" ? rawChain : Number(rawChain);
  if (!Number.isInteger(actual)) {
    throw new ChainMismatchError(Number.NaN, expected, endpoint);
  }
  if (actual !== expected) {
    throw new ChainMismatchError(actual, expected, endpoint);
  }
}
